import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { TokenService } from '../../shared/service/token.service';
import { EnvironmentService } from '../../shared/environment.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  interval: any;
  constructor(
    public tokenService: TokenService,
    public env: EnvironmentService
  ) {}
  refreshToken(refreshData: any): Observable<any> {
    return this.env
      .postWithoutToken(`refresh-token`, refreshData)
      .pipe(map((res) => res));
  }

  getTokenUsingRefreshToken() {
    if (this.tokenService.postWithoutToken()) {
      this.refreshToken(this.tokenService.postWithoutToken()).subscribe(
        (refreshTokenDetails: any) => {
          if (refreshTokenDetails?.body) {
            this.tokenService.removeToken();
            this.tokenService.removeRefreshToken();
            this.tokenService.saveToken(refreshTokenDetails?.body?.jwt);
            this.tokenService.saveRefreshToken(
              refreshTokenDetails?.body?.refreshToken
            );
          }
        }
      );
    }
  }

  refreshTokenInterval(time: any) {
    this.interval = setInterval(() => {
      this.getTokenUsingRefreshToken();
    }, time);
  }
}